import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { IField } from 'app/profile/models/dynamic-form.model';
import { I18nService } from 'app/shared/services/i18n.service';
import { saveAs } from 'file-saver';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'dynamic-form-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class DynamicFormFileUploadComponent implements OnInit {
  files = [];
  @Input() field: IField;
  _uploadedFiles: File[] = [];
  @Input() set uploadedFiles(value) {
    if (value && value.length && this.initialLoad) {
      this._uploadedFiles = value;
      this.updateFileInput();
    }
  }
  get uploadedFiles() {
    return this._uploadedFiles;
  }
  @Input() disableAction = false;
  @Input() multiple = false;
  @Input() accept: string;
  @Input() maxFileNameChars = 250;
  @Output() fileChange = new EventEmitter<File[]>();
  @Output() fileActionChange = new EventEmitter<any>();
  disableFileDrop = false;
  fileUploadLimit = 1;
  DEFAULT_FILE_TYPES = '.pdf,.doc,.docx';
  initialLoad = true;
  constructor(private translate: I18nService) {}

  ngOnInit(): void {
    if (!this.accept) {
      this.accept = this.DEFAULT_FILE_TYPES;
    }
  }
  updateFileInput() {
    this.initialLoad = false;
    this.uploadedFiles.forEach(file => {
      this.addUniqueFiles(file);
    });
  }
  onFileAdd(evt: File[]): void {
    const validFiles = evt.filter(file => file.name.length <= this.maxFileNameChars);
    if (validFiles.length !== evt.length) {
      return;
    }
    if (this.field) {
      const validBase64Files =
        validFiles?.map(async attachment => {
          return {
            fileName: attachment.name,
            file: attachment
          };
        }) ?? [];

      Promise.all(validBase64Files).then((res: any) => {
        this.files = [...this.files, ...res];
        this.emitEvent();
      });
    } else {
      this.files = [...this.files, ...validFiles];
      this.emitEvent();
    }
  }
  addUniqueFiles(file) {
    if (this.files.length) {
      if (this.files.indexOf(file) !== 1) {
        this.files.push(file);
      }
    } else {
      this.files = [file];
    }
  }
  readFileContent(file: File): Promise<string> {
    return new Promise<string>(resolve => {
      if (!file || typeof file.name !== 'string') {
        resolve('');
      }
      const reader = new FileReader();
      reader.onloadend = (e: ProgressEvent<any>): any => {
        // remove base64 header
        const base64String = e.target.result.split(',')[1];
        resolve(base64String);
      };
      reader.readAsDataURL(file);
    });
  }

  onFileRemove(file): void {
    this.files.filter((existingFile: any) => existingFile.fileName != file.fileName);
    this.files.splice(this.files.indexOf(file), 1);
    this.emitEvent();
  }

  emitEvent(): void {
    this.fileChange.emit(this.files);
  }

  downloadFile(file): void {
    if (!file) {
      return;
    }
    if (this.isNotNullOrUndefined(file) && file.name) {
      saveAs(file);
    } else {
      this.fileActionChange.emit({
        action: 'download',
        file: file
      });
    }
  }

  isNotNullOrUndefined(val: any): boolean {
    return typeof val !== 'undefined' && val !== null;
  }

  disableFileUpload(): boolean {
    return this.disableAction || (!this.multiple && this.files?.length >= this.fileUploadLimit);
  }
}
